export default __webpack_public_path__ + "static/media/furnished-finder.042254da.png";